import { render, staticRenderFns } from "./BookingDetails.vue?vue&type=template&id=53431fc0&"
import script from "./BookingDetails.vue?vue&type=script&lang=js&"
export * from "./BookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetails.vue?vue&type=style&index=0&id=53431fc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports